import {Caption, Colors} from '@dagster-io/ui-components';

export default function RecaptchaDisclaimer() {
  return (
    <Caption style={{textAlign: 'center'}} color={Colors.textLight()}>
      This site is protected by reCAPTCHA and the Google{' '}
      <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">
        Privacy Policy
      </a>{' '}
      and{' '}
      <a href="https://policies.google.com/terms" target="_blank" rel="noreferrer">
        Terms of Service
      </a>{' '}
      apply.
    </Caption>
  );
}
